import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBasketPageUSPs} from '../hooks/useGetBasketPageSection';
import {BasketUspsSkeleton} from './BasketUspsSkeleton';
import {BasketUspsView} from './BasketUspsView';

export const BasketUsps = () => {
  return (
    <DataFetcher
      request={useBasketPageUSPs()}
      Error={() => null}
      View={BasketUspsView}
      Loading={BasketUspsSkeleton}
    />
  );
};
